import { locationIdSchema } from "@repo/api/schemas";
import { useLocation } from "@repo/data-store";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { CatalogDefinition, LocationRead } from "@/features/catalog";

export const Route = createFileRoute("/catalog/locations/$locationId")({
  component: LocationDetailComponent,
});

function LocationDetailComponent() {
  const locationId = locationIdSchema.parse(Route.useParams().locationId);
  const { permissions, profile } = Route.useRouteContext();
  const navigate = useNavigate();
  const { location, isLoading } = useLocation(locationId);

  if (isLoading) {
    return <CatalogDefinition.Pending />;
  }

  if (!location) {
    return <CatalogDefinition.NotFound label="Location" backTo="/catalog/locations" backLabel="Back to locations" />;
  }

  return (
    <LocationRead
      key={locationId}
      locationId={locationId}
      location={location}
      canEdit={permissions.canWrite("Location")}
      profile={profile}
      onDeleted={() => navigate({ to: "/catalog/locations" })}
    />
  );
}
